export default "__VITE_ASSET__CabcC2k___";